export const SUPPORTED_LOCALES = ["en", "he"] as const;

export type LocaleKey = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: LocaleKey = "en";

export function normalizeLocale(locale: string | undefined): LocaleKey {
  return SUPPORTED_LOCALES.includes(locale as LocaleKey) ? (locale as LocaleKey) : DEFAULT_LOCALE;
}
